import { useAuditLogContext } from '../../contexts/AuditLogProvider';
import AcademiaFilterSelect from '../CommonComps/Inputs/AcademiaFilterSelect';

const AlterAuditLogsAction = () => {
  // integration of context hooks here
  const { filterList, setSelectedFilter } = useAuditLogContext();

  // rendering alter audit logs action component here
  return (
    <div className='w-full md:w-[250px]'>
      {filterList.length ? (
        <AcademiaFilterSelect
          options={filterList.filter((feature) => !feature.includes('Audit'))}
          onChangeHandler={(feature) => setSelectedFilter(feature)}
          defaultSelectedOption='Users'
          showSearchInput
          notFoundText='No Features Found!'
          variant='dark'
        />
      ) : null}
    </div>
  );
};

export default AlterAuditLogsAction;
